import { useMemo } from 'react'
import useOfferList from 'hooks/Offers/useOfferList'
import { OFFER_TYPE_BUNDLE_AND_SAVE, OFFER_TYPE_HOTEL } from 'constants/offer'
import useOfferListSortOptions from 'hooks/useOfferListSortOptions'
import { ANYWHERE_PLACE_ID } from 'constants/search'
import config from 'constants/config'

/**
 * Fetches offers sorted by ending soon
 * Returns offers that are close to their end date, sorted by those ending soonest first
 */
export default function useEndingSoonOfferList(): App.OfferList {
  const { SORT_OPTION_ENDING_SOON } = useOfferListSortOptions()
  const defaultRooms = useMemo(() => [config.search.defaultOccupants], [])

  const listFilters = useMemo<App.OfferListFilters>(() => ({
    offerTypes: [OFFER_TYPE_HOTEL, OFFER_TYPE_BUNDLE_AND_SAVE],
    frontPageVisibleOnly: true,
    isStream: true,
    limit: 12,
    sortBy: SORT_OPTION_ENDING_SOON.value as App.OfferListSortByOptions,
    destinationId: ANYWHERE_PLACE_ID,
    destinationName: 'Anywhere',
    rooms: defaultRooms,
  }), [defaultRooms, SORT_OPTION_ENDING_SOON])

  return useOfferList(listFilters, { minRequiredOffers: 12 })
}
